import { genericGet } from "../../services/api.service";
import { EntityConfig } from "../..";

export const OrcamentosTableConfigs: EntityConfig = [
  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },
  {
    id: 'client',
    label: 'Cliente',
    type: 'select',
    filterable: true,
    routable: true,
    options: {
      name: 'Cliente',
      route: 'clients',
      value: 'id',
      label: 'name',
      getter: () => genericGet('/findByFilter/clientes'),
      searcheable: true
    }
  },
  {
    id: 'name',
    label: 'Nome',
    type: 'text',
    filterable: true
  },
  {
    id: 'billCode',
    label: 'Nº Orçamento',
    type: 'text',
    filterable: true

  },
  {
    id: 'date',
    label: 'Data',
    type: 'date',
    filterable: true,

  },
  {
    id: 'valueWithoutIVA',
    label: 'Valor s/ IVA',
    type: 'number',
    displayInfo: 'currency'
  },
  {
    id: 'valueWithIVA',
    label: 'Valor c/ IVA',
    type: 'number',
    nonEditable: true,
    displayInfo: 'currency',
  },
  {
    id: 'acceptedPercentage',
    label: 'Percentagem Adjudicada',
    nonEditable: true,
    type: 'percentage',
    displayInfo: 'percentage'
  },
  {
    id: 'accepted',
    label: 'Aceite',
    type: 'boolean',
    filterable: true,
  },
  {
    id: 'obras',
    label: 'Obras',
    type: 'multi-select',
    routable: true,
    options: {
      name: 'Obras',
      route: 'obras',
      value: 'id',
      label: 'number',
      triggeredGetter: (i: number) => genericGet(`/obras/client/${i}`), // function to trigger according to other form parameter
      triggerParam: 'client', // Form parameter used to build getterfunction,
      getter: () => genericGet('/findByFilter/obras'),
      searcheable: true

    }
  },
  {
    id: 'pecasOrcamentadas',
    label: 'Qtd. Peças',
    type: 'multiple-create',
    displayFunction: (pecas: any) => pecas?.value?.length,
    options: {
      name: 'Peças',
      route: 'pecas',
      ref: 'pecas',
      value: 'id',
      label: 'reference',

    }
  },
  {
    id: 'importancia',
    label: 'Importância',
    type: 'enum',
  },
  

];